import React, { useState, useEffect } from 'react';
import { Checkbox } from 'rsuite';
import './report-configure.scss';
import { ReactComponent as ConfigureIcon } from '../../../assets/svg/configure.svg';
import { useRef } from 'react';
import { default as t } from '../../../utils/i18n';

const ReportConfigure = props => {
  const [breakdownAttribute, setBreakdownAttribute] = useState([]);
  const [errorMessage, setErrorMessage] = useState('');
  const [warningMessage, setWarningMessage] = useState(t('report.breakdowntable.important.msg'));
  const [orderAttr, setOrderAttr] = useState([]);
  const ORDERED = useRef([]);
  useEffect(() => {
    setOrderAttr([...orderAttr, ...props?.savedOrdered])
    if (props?.attributes.filter(x => x.isChecked).length === 3) {
      props?.attributes.forEach(item => {
        if (!item.isChecked && !item.isDisabled) {
          item.isDisabled = true;
        }
      });
      setErrorMessage(t('report.breakdowntable.warning.msg'));
    } else {
      const invalidAttributes = props?.attributes
        .filter(item => item.isChecked)
        .flatMap(item => item.invalid_combination);
        let invalid_combination = [];
        let mandateCombination = [];
        props?.savedOrdered?.map(li => {
          if (li.invalid_combination?.length > 0) {
            invalid_combination.push(li.invalid_combination);
          }
          if (li.mandate_combination?.length > 0) {
            mandateCombination.push(li.mandate_combination);
          }
        });
        let invalid_combination_res = [...new Set(invalid_combination?.flat(1))];
        let mandateCombination_res = [...new Set(mandateCombination?.flat(1))];
        let checkedVal = props?.attributes.filter(x => x.isChecked);
      if(!mandateCombination_res?.length) {
        props?.attributes?.forEach(element => {
          if (
            props?.attributes.filter(x => x.isChecked).length === 2 &&
            element?.mandate_combination?.length > 0 && !checkedVal?.some(ele => element?.mandate_combination.includes(ele?.sys_id))
          ) {
            element.isDisabled = true;
          } else {
            element.isDisabled =
              !element?.isChecked && invalid_combination_res?.length
                ? invalid_combination_res?.includes(element?.sys_id)
                  ? true
                  : false
                : false;
          }
        });
      }
      
    }
    if (props?.data?.attributes.length === 0) {
      ORDERED.current = [];
    } else {
      ORDERED.current = props?.savedOrdered;
    }
    setBreakdownAttribute(props?.attributes);
  }, []);

  const checkOrUnCheckAttr = (attr, index) => {
    breakdownAttribute[index].isChecked = !attr.isChecked;
    pushIfNotExists(breakdownAttribute, index);
    let checkedAttr = [];
    breakdownAttribute.forEach(res => {
      if (res.isChecked) {
        checkedAttr.push(res);
      }
    });
    let invalid_combination = [];
    let mandateCombination = [];
    checkedAttr.map(li => {
      if (li.invalid_combination?.length > 0) {
        invalid_combination.push(li.invalid_combination);
      }
      if (li.mandate_combination?.length > 0) {
        mandateCombination.push(li.mandate_combination);
      }
    });
    let invalid_combination_res = [...new Set(invalid_combination?.flat(1))];
    let mandateCombination_res = [...new Set(mandateCombination?.flat(1))];
    if (invalid_combination_res?.length > 0 || mandateCombination_res?.length > 0) {
      breakdownAttribute.forEach(res => {
        if (invalid_combination_res?.includes(res.sys_id)) {
          res.isChecked = false;
          res.isDisabled = true;
        }
        if (mandateCombination_res?.includes(res.sys_id)) {
          checkedAttr.push(res);
          res.isChecked = true;
          res.isDisabled = true;
        }
      });
    }
    checkedAttr = [...new Set(checkedAttr)]
    props?.setCanCreateList(!checkedAttr?.length);
    const disabledChecked = breakdownAttribute.filter(x => x.isDisabled).length;
    if (checkedAttr?.length === 3) {
      breakdownAttribute.forEach(item => {
        if (!item.isChecked && !item.isDisabled) {
          item.isDisabled = true;
        }
      });
      setErrorMessage(t('report.breakdowntable.warning.msg'));
      setBreakdownAttribute([...breakdownAttribute]);
    } else if (
      (checkedAttr?.length === 1 || checkedAttr?.length === 2) &&
      !mandateCombination_res?.length
    ) {
      breakdownAttribute.forEach(element => {
        if (checkedAttr?.length === 2 && element?.mandate_combination?.length > 0 && !checkedAttr?.some(ele => element?.mandate_combination.includes(ele?.sys_id))) {
          element.isDisabled = true;
        } else {
          element.isDisabled =
            !element?.isChecked && invalid_combination_res?.length
              ? invalid_combination_res?.includes(element?.sys_id)
                ? true
                : false
              : false;
        }
      });
    } else if (!checkedAttr?.length) {
      breakdownAttribute.forEach(ele => {
        ele.isChecked = false;
        ele.isDisabled = false;
      });
    } else {
      if (disabledChecked > 5) {
        const invalidAttributes = breakdownAttribute
          .filter(item => item.isChecked)
          .flatMap(item => item.invalid_combination);

        breakdownAttribute.forEach(item => {
          item.isDisabled =
            invalidAttributes.includes(item.sys_id) ||
            mandateCombination_res?.includes(item?.sys_id);
        });
      }
      setErrorMessage('');
    }
    if([...breakdownAttribute][index]?.isChecked) {
      setOrderAttr([...orderAttr, breakdownAttribute[index]]);
      checkedAttr.forEach(res => {
        if (mandateCombination_res?.includes(res.sys_id)) {
          if(orderAttr.some(attr => attr?.sys_id === res.sys_id)) {
            setOrderAttr([...orderAttr, breakdownAttribute[index]]);
          } else {
            setOrderAttr([...orderAttr, breakdownAttribute[index], res]);
          }
        }
      })
    } else {
      const filteredAttr = orderAttr.filter(item => item.sys_id !== attr.sys_id);
      setOrderAttr([...filteredAttr]);
    }
    setBreakdownAttribute([...breakdownAttribute]);
  };

  function removeDuplicates(array) {
    return [...new Set(array)];
  }

  function pushIfNotExists(breakdownAttribute, index) {
    const itemToPush = breakdownAttribute[index];
    if (itemToPush.isChecked) {
      ORDERED.current.push(itemToPush);
      if (breakdownAttribute[index]?.mandate_combination?.length > 0) {
        const mandateItem = new Set(breakdownAttribute[index]?.mandate_combination);
        breakdownAttribute.forEach(element => {
          if (mandateItem.has(element.sys_id)) {
            ORDERED.current.push(element);
          }
        });
      }
      ORDERED.current = removeDuplicates(ORDERED.current);
    } else {
      if (ORDERED.current.includes(itemToPush)) {
        ORDERED.current = ORDERED.current.filter(item => item.sys_id !== itemToPush.sys_id);
      }
    }
  }

  return (
    <div className="report-configure-container">
      <div className="heading-container-modal edit-label">
        <div className="flexbox">
          <ConfigureIcon />
          <p>{t('report.configure')}</p>
        </div>
        <div onClick={() => props?.handleOpenSliderModal(true)}>
          <i
            data-tip="Edit nickname"
            data-for="tool-tip"
            className="eva eva-close-outline clear-icon close-btn"
            currentitem="false"
          ></i>
        </div>
      </div>
      <p className="warning">
        <i className="eva eva-info-outline"></i>
        {warningMessage}
      </p>
      {errorMessage.length > 0 ? <p className="error">{errorMessage}</p> : ''}
      <h6>{t('report.table.title')}: {props?.data?.breakDownName}</h6>
      <h6>{t('report.table.choose.attributes')}</h6>
      <div className="checkbox-container">
        {breakdownAttribute?.map((attr, index) => (
          <span className='each_attribute'>
            <Checkbox
              disabled={attr.isDisabled}
              checked={attr.isChecked}
              key={Math.random().toString()}
              onChange={() => checkOrUnCheckAttr(attr, index)}
            />
            <label title={attr.name}>{attr.name}</label>
          </span>
        ))}
      </div>

      <div className="button-container">
        <button className="cancel-btn" onClick={() => props?.handleOpenSliderModal(true)}>
          {t('report.table.bd.cancel')}
        </button>
        <button
          className={props?.canCreateList ? 'step-next disabled' : 'step-next'}
          onClick={() => props?.handleOpenSliderModal(true, breakdownAttribute, ORDERED.current, orderAttr)}
          disabled={props?.canCreateList}
        >
          {t('report.table.bd.create')}
        </button>
      </div>
    </div>
  );
};

export default ReportConfigure;
